<template>
  <li class="list-item">
    <article class="box item-content">
      <div>
        <header class="header">
          <slot name="header" />
        </header>
        <slot />
      </div>
      <div class="row">
        <slot name="actions" />
      </div>
    </article>
  </li>
</template>

<style scoped>
.list-item {
  &:nth-child(even) {
    background-color: var(--bg-color-tr-even);
  }

  &:nth-child(odd) {
    background-color: var(--bg-color-tr-odd);
  }
}

.item-content {
  display: flex;
  gap: var(--spacing-sm);
  justify-content: space-between;
}

:deep(.header > *) {
  overflow-wrap: anywhere;
}
</style>
